import { DefaultTransactionColumnValue } from "./DefaultTransactionColumnValue";
import { TransactionColumnSizer } from "./TransactionColumnSizer";
import { TransactionColumn } from "./TransactionColumn";
import { buildClasses } from "../utils/buildClasses";
import { useContext } from "react";
import { TransactionRowContext } from "./TransactionRow";
import { RyeTooltip } from "../rye/RyeTooltip";

export function TransactionColumnValueType({
  type,
  subtype,
}: {
  type: string | null;
  subtype: string | null;
}): JSX.Element {
  const { ruleForFieldHighlighting } = useContext(TransactionRowContext);

  if (type !== null) {
    const typeTokenCommonClasses = buildClasses(
      "py-0.5",
      "text-sm",
      "border",
      "border-on-surface-300",
    );

    return (
      <TransactionColumnSizer column={TransactionColumn.TYPE}>
        <DefaultTransactionColumnValue
          ruleHighlight={
            ruleForFieldHighlighting.get !== null &&
            (ruleForFieldHighlighting.get.criteria.type !== null ||
              ruleForFieldHighlighting.get.criteria.subtype !== null)
          }
        >
          <RyeTooltip text={`Transaction type: ${type}`}>
            <div
              className={buildClasses(
                typeTokenCommonClasses,
                "pr-2",
                "pl-3",
                "flex-shrink-0",
                "rounded-l-full",
                "whitespace-nowrap",
                "overflow-hidden",
                "overflow-ellipsis",
              )}
            >
              {type}
            </div>
          </RyeTooltip>
          {subtype && (
            <RyeTooltip text={`Transaction subtype: ${subtype}`}>
              <div
                className={buildClasses(
                  typeTokenCommonClasses,
                  "pr-3",
                  "pl-2",
                  "border-l-0",
                  "rounded-r-full",
                  "whitespace-nowrap",
                  "overflow-hidden",
                  "overflow-ellipsis",
                )}
              >
                {subtype}
              </div>
            </RyeTooltip>
          )}
        </DefaultTransactionColumnValue>
      </TransactionColumnSizer>
    );
  }

  return <TransactionColumnSizer column={TransactionColumn.TYPE} />;
}
